import {
  createApi,
  createAuth,
  createCart,
  createStorage,
  createStrapi,
} from "@monta/utils";

const storage = createStorage();

const auth = createAuth(storage, {});

const api = createApi({
  auth,
});

const cart = createCart(api);

const strapi = createStrapi();

export { api, auth, storage, cart, strapi };

export * from "./isNumeric";
